module.exports = __webpack_public_path__ + "18c9c15ae898f16887b043a611dfbe4b.jpg";